<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer002">
<div class="_idGenObjectLayout-1">
<div id="_idContainer003">
<img alt="" class="_idGenObjectAttribute-1" src="image/DedicationLogo.jpg" style="width: 20%;"/>
</div>
</div>
<p class="Chapter-Headers" id="_idParaDest-1"><a id="_idTextAnchor000"></a>Dedication</p>
<p class="Dedication"><span class="CharOverride-1">The College of Our Lady of the Elms</span></p>
<p class="Dedication"><span class="CharOverride-1">Chicopee, Massachusetts</span></p>
<p class="Dedication"><span class="CharOverride-1">Dedicates this Work</span></p>
<p class="Dedication"><span class="CharOverride-1">To the Memory of</span></p>
<p class="Dedication"><span class="CharOverride-1">Father Hugh Francis Crean, PhD, STD</span></p>
<p class="Dedication"><span class="CharOverride-1">(1937–2015)</span></p>
<p class="Dedication"><span class="CharOverride-1">Parish Priest, Professor and College Trustee, Visionary, and Friend</span></p>
<p class="Dedication"><span class="CharOverride-1">And to the Members of</span></p>
<p class="Dedication"><span class="CharOverride-1">The Crean and Andrews Families</span></p>
<p class="Dedication top1"><span class="Italic CharOverride-2">In the face of a true friend, one finds a second self.</span></p>
<p class="Dedication"><span class="CharOverride-1">—Cicero,</span><span class="Italic CharOverride-3"> De Amititia</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// AlongTheWay_ebook-1.vue?e09d72ac